import { render } from "./SelectRichText.vue?vue&type=template&id=659918cc&scoped=true"
import script from "./SelectRichText.vue?vue&type=script&lang=js"
export * from "./SelectRichText.vue?vue&type=script&lang=js"

import "./SelectRichText.vue?vue&type=style&index=0&id=659918cc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-659918cc"]])

export default __exports__